/**
 * Colored abbreviation tag for the row gutter of a RelationshipTree row.
 *
 * Reads the entity's label/abbreviation/color from `config.entityConfig` keyed
 * by `entityOrGroupId`. Tooltip shows the long label; the visible tag shows the
 * short abbreviation. Falls back to `'N/A'` / the raw id / `'default'` when the
 * entity is unknown so an undocumented entity type still renders visibly.
 */
import { FC, CSSProperties } from 'react';
import { Tag, Tooltip } from 'antd';
import type { RelationshipTreeConfig } from '#types/System.RelationshipTree.types';

type NodeTagProps = {
  entityOrGroupId: string;
  config: RelationshipTreeConfig;
  style?: CSSProperties;
};

const NodeTag: FC<NodeTagProps> = ({ entityOrGroupId, config, style }) => {
  const entityConfig = config.entityConfig[entityOrGroupId];
  const abbreviation = entityConfig?.abbreviation ?? 'N/A';
  const label = entityConfig?.label ?? entityOrGroupId;
  const color = entityConfig?.color ?? 'default';

  return (
    <Tooltip title={label}>
      <Tag color={color} style={{ cursor: 'default', ...style }}>
        {abbreviation}
      </Tag>
    </Tooltip>
  );
};

export default NodeTag;
